import { LocationDataGeocoded } from '../location';
import { GpdrData } from './gpdr-data';
import { MarketingData } from './marketing-data';

export interface DossierLastStepForm {
  lastname?: string;
  firstname?: string;
  email?: string;
  phone?: string;
  phoneCountry?: string;
  message?: string;
  notificationType?;
  ownerShipType?: string;
  ownerShipName?: string;
  insuranceChoice?: string;
  insuranceName?: string;
  gpdr?: GpdrData;
  marketingData?: MarketingData;
  contactPeriod?: string;
  customerLocation?: LocationDataGeocoded;
  selectedFitter?: {
    fitterId: string;
    ihm: string;
    brandId: string;
    timezone: string;
  };
}
